module.exports = __webpack_public_path__ + "static/media/sognolucido_mobile.ed053b44.jpg";